<div class="contact-container">
</div>
<div class="contact">
  <div class="contact__header">
    <span class="contact__header--text">{{'CONTACT' | translate}}</span>
  </div>
  <div class="contact__body">
    <div class="contact__form" *ngIf="false">
      <h2>{{'CONTACT_CITY_EXPERT' | translate}}</h2>
      <p>{{'CONTACT_CITY_EXPERT2' | translate}}</p>
      <div class="contact__form--container">
        <contact-form></contact-form>
      </div>
    </div>
    <div class="contact__desktop">
      <div class="contact__address">
        <div class="contact__address--info">
          <div class="contact__address--inner">
            <img src="../../assets/images/icono-localizacion-mobile.png" alt="" width="35px">
          </div>
          <span>Calle Jaén, 2 – 41001 Sevilla</span>
        </div>
        <div class="contact__address--info">
          <div class="contact__address--inner">
            <img src="../../assets/images/icono-mail-mobile.png" alt="" width="42px">
          </div>
          <span>info@cityexpert.travel</span>
        </div>
        <div class="contact__address--info">
          <div class="contact__address--inner">
            <img src="../../assets/images/icono-telefono-mobile.png" alt="" width="35px">
          </div>
          <span>(+34) 900 920 092</span>
        </div>
        <div class="contact__icon-container">
          <h2>{{'CONTACT_FOLLOW' | translate}}</h2>
          <ul class="contact__icon-list">
            <li class="contact__icon-shape">
              <a class="contact__icon-shape-anchor" target="_blank" href="https://twitter.com/CityExpert_">
                <img src="../../assets/images/rrss-twitter.png" alt="Twitter logo">
                <span>Twitter</span>
              </a>
            </li>
            <li class="contact__icon-shape">
              <a class="contact__icon-shape-anchor" target="_blank" href="https://www.facebook.com/CityExpertTravel/">
                <img src="../../assets/images/rrss-facebook.png" alt="Facebook logo">
                <span>Facebook</span>
              </a>
            </li>
            <li class="contact__icon-shape">
              <a class="contact__icon-shape-anchor" target="_blank" href="https://www.instagram.com/city_expert/">
                <img src="../../assets/images/rrss-instagram.png" alt="Instagram logo">
                <span>Instagram</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="contact__mobile">
        <div class="contact__icon-mobile">
          <div class="contact__icon-mobile--inner">              
            <div class="contact__icon-mobile__image">
                
              <img src="../../assets/images/icono-localizacion-mobile.png" alt="" width="70px">
            </div>
            <div class="contact__icon-mobile__text">
              <span class="display-block">Calle Jaén, 2</span>
              <span class="display-block">41001 Sevilla</span>
            </div>
          </div>
          <div class="contact__icon-mobile--inner">
            <div class="contact__icon-mobile__image">
              <img src="../../assets/images/icono-mail-mobile.png" alt="" width="70px">
            </div>
            <div class="contact__icon-mobile__text">
              <span>info@cityexpert.travel</span>
            </div>
          </div>
          <div class="contact__icon-mobile--inner">
            <div class="contact__icon-mobile__image">
              <img src="../../assets/images/icono-telefono-mobile.png" alt="" width="70px">
            </div>
            <div class="contact__icon-mobile__text">
              <span>(34) 900 99 920 092</span>
            </div>
          </div>
        </div>
        <div class="contact__rrss-mobile">
          <h2 class="contact__rrss-mobile-text">{{'CONTACT_FOLLOW' | translate}}</h2>
          <ul class="contact__rrss-mobile-list">
            <li class="contact__rrss-mobile-shape">
              <a class="contact__rrss-mobile-shape-anchor" target="_blank" href="https://twitter.com/CityExpert_">
                <div class="contact__rrss-mobile--image-size">
                  <img src="../../assets/images/rrss-twitter.png" alt="Twitter logo">
                </div>
                <span>Twitter</span>
              </a>
            </li>
            <li class="contact__rrss-mobile-shape">
              <a class="contact__rrss-mobile-shape-anchor" target="_blank" href="https://www.facebook.com/CityExpertTravel/">
                <div class="contact__rrss-mobile--image-size">
                  <img src="../../assets/images/rrss-facebook.png" alt="Facebook logo">
                </div>
                <span>Facebook</span>
              </a>
            </li>
            <li class="contact__rrss-mobile-shape">
              <a class="contact__rrss-mobile-shape-anchor" target="_blank" href="https://www.instagram.com/city_expert/">
                <div class="contact__rrss-mobile--image-size">
                  <img src="../../assets/images/rrss-instagram.png" alt="Instragram logo">
                </div>
                <span>Instagram</span>
              </a>
            </li>
          </ul>
        </div>
    </div>
  </div>
</div>